// Keep the existing YOTY information-page route for its database entry.
export const eventPath = (event) => /\byoty\b|youth of the year/i.test(event.title || '')
  ? '/event/yoty'
  : `/event/${event.id}`;

export const YOTY_BANNER = "/yoty/oct23/yoty-banner.jpg";
export const eventImage = event => eventPath(event) === "/event/yoty" ? YOTY_BANNER : event.image;
